import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="design-iconfont"
    >
      <g fill-rule="nonzero">
        <path
          d="M1.16666665,1.2788931 L7,1.2788931 C7.77777778,1.2788931 8.16666665,1.66778198 8.16666665,2.44555974 L8.16666665,8.2788931 C8.16666665,9.05667088 7.77777777,9.44555974 7,9.44555974 L1.16666665,9.44555974 C0.388888865,9.44555974 6.26905935e-14,9.05667086 6.26905935e-14,8.2788931 L6.26905935e-14,2.44555974 C6.26905935e-14,1.66778196 0.388888883,1.2788931 1.16666665,1.2788931 Z"
          transform="translate(2 2)"
        />
        <path
          d="M11.6666666,11.7788931 L17.5,11.7788931 C18.2777778,11.7788931 18.6666666,12.167782 18.6666666,12.9455597 L18.6666666,18.7788931 C18.6666666,19.5566709 18.2777778,19.9455597 17.5,19.9455597 L11.6666666,19.9455597 C10.8888889,19.9455597 10.5,19.5566709 10.5,18.7788931 L10.5,12.9455597 C10.5,12.167782 10.8888889,11.7788931 11.6666666,11.7788931 Z"
          transform="translate(2 2)"
        />
        <path
          d="M15.4082912,0.412478951 L19.5330808,4.53726852 C20.0830527,5.08724045 20.0830527,5.63721239 19.5330808,6.18718432 L15.4082912,10.3119739 C14.8583193,10.8619458 14.3083474,10.8619458 13.7583754,10.3119739 L9.63358586,6.18718432 C9.08361392,5.63721239 9.08361392,5.08724045 9.63358586,4.53726852 L13.7583754,0.412478951 C14.3083474,-0.137492984 14.8583193,-0.137492984 15.4082912,0.412478951 Z"
          transform="translate(2 2)"
        />
        <path
          d="M1.16666665,11.7788931 L7,11.7788931 C7.77777778,11.7788931 8.16666665,12.167782 8.16666665,12.9455597 L8.16666665,18.7788931 C8.16666665,19.5566709 7.77777777,19.9455597 7,19.9455597 L1.16666665,19.9455597 C0.388888865,19.9455597 6.26905935e-14,19.5566709 6.26905935e-14,18.7788931 L6.26905935e-14,12.9455597 C6.26905935e-14,12.167782 0.388888883,11.7788931 1.16666665,11.7788931 Z"
          transform="translate(2 2)"
        />
      </g>
    </svg>
  )
}
const AppsIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
AppsIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
AppsIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default AppsIcon
